import React from "react";

import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';


const GradientCircularProgress: React.FC = () => (
  <>
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2191d2" />
          <stop offset="100%" stopColor="#8661B4" />
        </linearGradient>
      </defs>
    </svg>
    <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
  </>
);

const Loading: React.FC = () => (
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }}
  >
    <GradientCircularProgress />
  </Box>
);

export default Loading;
